import { createAsyncTypes } from 'utils/ActionCreator'
import { URL_CONST } from 'utils/urlConsts'

export const FETCH_BASIC_SETUP_ASYNC = createAsyncTypes('FETCH_BASIC_SETUP', 'AccountSetup')
export const TOGGLE_DISMISS_ASYNC = createAsyncTypes('TOGGLE_DISMISS', 'AccountSetup')

export const SETUP_STEPS = {
  mailServerIntegration: {
    text: 'Integrate Mail Server',
    url: URL_CONST.settings.emailServer,
    kb: 'https://support.ironscales.com/hc/en-us/sections/360001408971',
  },
  addMailboxes: {
    text: 'Upload Mailboxes',
    url: URL_CONST.mailboxes.upload,
    modal: {
      video: 'https://www.youtube.com/embed/k0WStLbX04k',
      kbLinks: [
        {
          link: 'https://support.ironscales.com/hc/en-us/sections/360004940919-Upload-Sync-Mailboxes',
        },
      ],
    },
  },
  '911MailboxIntegration': {
    text: 'Configure 911 Mailbox',
    url: URL_CONST.settings.emailServer,
    kb: 'https://support.ironscales.com/hc/en-us/articles/360004719772-911',
  },
  vip: {
    text: 'Mark VIP Mailboxes',
    url: URL_CONST.mailboxes.management,
    modal: {
      video: 'https://www.youtube.com/embed/zI1zEg-Uoj0',
      kbLinks: [
        {
          link: 'https://support.ironscales.com/hc/en-us/articles/360017446040-VIP-Impersonation',
        },
      ],
    },
  },
  communityUsername: {
    text: 'Set a nickname for Community',
    url: URL_CONST.settings.profile,
    kb:
      'https://support.ironscales.com/hc/en-us/articles/360017556619-Analysts-' +
      'Communication-Share-your-classification-comments-within-the-community-',
  },
  mobileIntegration: {
    text: 'Set Mobile Push Notifications',
    kb:
      'https://support.ironscales.com/hc/en-us/restricted?return_to=https%3A%2F%2F' +
      'support.ironscales.com%2Fhc%2Fen-us%2Farticles%2F4684584160156-IRONSCALES-Mobile-App',
  },
  siemIntegration: {
    text: 'SIEM Integration Account',
    url: URL_CONST.settings.alerts,
    kb: 'https://support.ironscales.com/hc/en-us/articles/360004775971-SIEM',
  },
  collaborationIntegration: {
    text: 'Integration With Collaboration Tools',
    url: URL_CONST.settings.collaborationApps,
    kb: 'https://support.ironscales.com/hc/en-us/articles/360018577360-Collaboration-Apps-',
  },
}
